import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReservaService } from '@infra/reserva/reserva.service';
import { TermsService } from './dialog-terms.service';
import FullEditor from 'ckeditor5-build-full'

@Component({
  selector: 'app-dialog-terms',
  templateUrl: './dialog-terms.component.html',
  styleUrls: ['./dialog-terms.component.scss'],
})
export class DialogTermsComponent implements OnInit {
  termosCondicoes: any
  public Editor = FullEditor;
  public editorConfig = {
    toolbar: [],
    link: {
      addTargetToExternalLinks: true
    },
  };

  constructor(
    private dialogRef: MatDialogRef<DialogTermsComponent>,
    public reservaService: ReservaService,
    private termsService: TermsService,
    @Inject(MAT_DIALOG_DATA) public data: number | string
  ) { }

  ngOnInit() {
    this.termosCondicoes = sessionStorage.getItem('termosCondicoes')
  }

  acceptTerms() {
    this.dialogRef.close(true);
  }
}
